import { j as r, B as f } from "./Spinner-dTAYYnIx.js";
import { useState as $, useRef as b, useEffect as x } from "react";
import { styled as a, css as y } from "styled-components";
import { s as g, j as h, e as j } from "./style-8UHgYe1v.js";
import { I } from "./Image-8P7BYQsX.js";
import { A as d } from "./aspect-ratios-JlfRqse9.js";
import { f as V, z as l } from "./index-QRkynDgW.js";
import { V as w } from "./icon-video-QAWE7HEQ.js";
const v = a.div`
  display: grid;
  position: relative;
  grid-row-start: 1;
  grid-column-start: 1;
  aspect-ratio: ${d["16:9"]};
`, z = a.iframe`
  position: absolute;
  aspect-ratio: ${d["16:9"]};
  ${g("100%")}
  grid-row: auto;
  grid-column: auto;
`, B = a(I)`
  ${h("opacity, visibility", j.base)}

  ${({ $hidden: s }) => y`
    visibility: ${s ? "hidden" : "visible"};
    opacity: ${s ? 0 : 1};
  `}
`, C = a.div.attrs({ $justifyContent: "center", $alignItems: "center" })`
  height: 100%;
  ${V}
`, S = {
  brightcove: "&autoplay",
  embedded: "&play=1",
  youtube: "?autoplay=1"
}, D = ({ ariaLabel: s = "Play video", images: i, videoType: n, videoUrl: o, ...u }) => {
  const [e, m] = $(!i), t = b(null), p = o && n && `${o}${S[n]}`;
  return x(() => {
    var c;
    t != null && t.current && ((c = t == null ? void 0 : t.current) == null || c.focus());
  }, [e]), i || o ? /* @__PURE__ */ r.jsxs(v, { "data-qa": `video-component-${n}`, ...u, children: [
    i && /* @__PURE__ */ r.jsx(B, { images: i, objectFit: "contain", isBackgroundImage: !0, $hidden: e, children: o && /* @__PURE__ */ r.jsx(C, { children: /* @__PURE__ */ r.jsx(
      f,
      {
        variant: "media-control",
        size: "lg",
        icon: { icon: w },
        "aria-label": s,
        onClick: () => m(!0)
      }
    ) }) }),
    o && /* @__PURE__ */ r.jsx(
      z,
      {
        ref: t,
        frameBorder: "0",
        marginWidth: 0,
        marginHeight: 0,
        scrolling: "no",
        allow: "fullscreen; autoplay; encrypted-media;",
        src: i && e ? p : o,
        title: "video-iframe",
        tabIndex: e ? 0 : -1,
        style: { zIndex: e ? l.base : l.below }
      }
    )
  ] }) : null;
};
export {
  D as V
};
